const CURRENCY_PATTERN = /₽|руб/i;

export function getPromoActionLabel(code: string): string {
  return code.trim() ? 'Получить промокод' : 'Получить акцию';
}

export function getPromoBadgeLabel(discount: string): string {
  const normalized = discount.trim();
  if (!normalized) {
    return 'Акция';
  }

  if (/бесплат[^ ]*\s+доставк/i.test(normalized)) {
    return 'Бесплатная доставка';
  }

  if (/%|₽|руб/i.test(normalized)) {
    return normalized;
  }

  if (/бесплатно/i.test(normalized)) {
    return 'Бесплатно';
  }

  return 'Акция';
}

export function getPromoBadgeTextClass(discount: string): string {
  const label = getPromoBadgeLabel(discount);

  if (label.length >= 18) {
    return 'text-base leading-tight';
  }

  if (label.length >= 12) {
    return 'text-lg leading-tight';
  }

  if (label.length >= 8) {
    return 'text-2xl leading-tight';
  }

  return 'text-4xl leading-none';
}

export function parseDiscountValue(discount: string): { value: number; unit: 'percent' | 'currency' | 'other' } {
  const match = discount.match(/\d+(?:[.,]\d+)?/);
  const rawValue = match ? Number(match[0].replace(',', '.')) : 0;

  if (discount.includes('%')) {
    return { value: rawValue, unit: 'percent' };
  }

  if (CURRENCY_PATTERN.test(discount)) {
    return { value: rawValue, unit: 'currency' };
  }

  return { value: rawValue, unit: 'other' };
}

export function getBestDiscountLabel(discounts: string[]): string {
  const parsed = discounts.map(parseDiscountValue);
  const percentValues = parsed.filter((item) => item.unit === 'percent').map((item) => item.value);

  if (percentValues.length > 0) {
    return `${Math.max(...percentValues)}%`;
  }

  const currencyValues = parsed.filter((item) => item.unit === 'currency').map((item) => item.value);
  if (currencyValues.length > 0) {
    return `${Math.max(...currencyValues)}₽`;
  }

  const numericValues = parsed.map((item) => item.value).filter((value) => value > 0);
  return numericValues.length > 0 ? String(Math.max(...numericValues)) : 'Акция';
}
